import React from 'react';
import type {TaskAssignmentResponse} from 'src/api/ProactApiClient';
import {TaskTypeEnum} from 'src/api/ProactApiClient';
import {DocumentUnderReviewPanel} from 'src/app/tasks/DocumentUnderReviewPanel';
import {ViewLinkedDemonstrationSection} from 'src/app/training/ViewLinkedDemonstrationSection';
import {ViewLinkedWorkflowSection} from 'src/app/workflows/ViewLinkedWorkflowSection';

export interface TaskAssignmentSupportingSectionsProps {
  viewItem: TaskAssignmentResponse | undefined;
}

/**
 * Supporting context beside a task assignment: document under review, linked demonstration and workflow.
 * @registry Task-assignment side content (review document, linked demonstration, linked workflow).
 */
export const TaskAssignmentSupportingSections: React.FC<
  TaskAssignmentSupportingSectionsProps
> = ({viewItem}) => {
  const reviewDocumentId = viewItem?.taskDefinition.documentId;
  const reviewTaskType = viewItem?.taskDefinition.taskType;
  const showDocumentPanel =
    !!reviewDocumentId &&
    (reviewTaskType === TaskTypeEnum.Approval ||
      reviewTaskType === TaskTypeEnum.ToolboxTalk);

  return (
    <>
      {showDocumentPanel && reviewDocumentId && (
        <DocumentUnderReviewPanel
          documentId={reviewDocumentId}
          documentVersion={viewItem?.taskDefinition.documentVersion ?? undefined}
        />
      )}
      {viewItem?.taskDefinition?.demonstrationId && (
        <ViewLinkedDemonstrationSection taskAssignmentId={viewItem.id} />
      )}
      <ViewLinkedWorkflowSection
        taskAssignmentId={viewItem?.id}
        taskDefinitionId={viewItem?.taskDefinition.id}
      />
    </>
  );
};
